const Spinner = ({ size }) => {
  const baseClass = 'spinner';
  let classNames = [baseClass];
  let sizeClassName;

  switch (size) {
    case 'small':
      sizeClassName = `${baseClass}--xs`;
      break;
    case 'medium':
      sizeClassName = `${baseClass}--md`;
      break;
    default:
      sizeClassName = undefined;
  }

  sizeClassName && classNames.push(sizeClassName);

  let spinnerWrapper = document.createElement('div');
  spinnerWrapper.setAttribute('class', classNames.join(' '));

  [...Array(12)].forEach((_, index) => {
    let spinnerCircle = document.createElement('div');
    spinnerCircle.setAttribute('class', `spinner__circle spinner__circle--${index + 1}`);

    spinnerWrapper.appendChild(spinnerCircle);
  });

  return spinnerWrapper;
};

export default Spinner;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/spinner/index.js